<template>
  <div class="py-3 container-fluid space-y-4">

    <!-- Header usuario y fechas -->
    <div class="bg-white rounded-xl shadow-md p-3">
      <div class="flex flex-col md:flex-row md:items-center gap-3">
        <!-- Usuario -->
        <div class="flex items-center gap-3 w-full">
          <img :src="acreditado && acreditado.foto ? acreditado.foto : require('@/assets/img/nologo.png')" class="shadow-sm w-16 rounded-lg" />
          <div class="flex flex-col">
            <h5 class="text-xl font-bold mb-1 text-slate-800">{{ acreditado ? acreditado.nombre + " " +
              acreditado.apellido : $t('label.cargando') }}</h5>
            <p class="mb-0 text-xs text-slate-500">{{ $t('label.fecha.alta') }} : {{ acreditado ?
              formatDate(acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : $t('label.cargando') }}</p>
          </div>
        </div>
        <div class="mx-auto mt-4 px-4 w-full md:w-1/2 lg:w-1/3 sm:my-auto sm:ml-auto sm:mr-0">
          <div class="relative w-full text-right">

            <button @click="downloadAgendaPdf" class="px-5 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
              <font-awesome-icon :icon="['faf', 'fa-file-pdf']" class="mr-2" />{{ $t('boton.download.pdf') }}
            </button>
            
          </div>
        </div>        
      </div>
    </div>
    <!-- Fin header usuario y fechas -->


    <!-- Agenda -->
    <div class="bg-white rounded-xl shadow-md">

      <div class="p-3 mb-2 space-y-2">
        <h6 class="text-lg font-bold text-slate-800">{{ $t('menu.agenda') }}</h6>

        <span class="text-gray-600 text-sm font-light">{{ $t('label.selecciona.fecha') }}</span>
        <NavPill :items="fechas" v-model="fechaSeleccionada" :onChange="onChangeFechaCronograma" />
      </div>

      <ul class="divide-y divide-gray-200 list-none pb-4">
        <li @click="mostrarDetalleAgenda(item)" v-for="(item, i) in detallesAgenda" :key="i"
          class="hover:bg-gradient-to-r from-gray-200 to-gray-50 cursor-pointer">
          <div class="flex items-center gap-3 py-2 mx-3">
            <div class="h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border"
              :style="{ borderColor: item.colorEstado, color: item.colorEstado }">
              <font-awesome-icon :icon="getIcono(item)" class="text-2xl" />
            </div>

            <div class="flex-1 text-left">
              <div class="text-sm md:text-lg font-semibold">{{ item.cronograma.horaDesde }}</div>
              <div class="text-sm font-semibold text-gray-700 uppercase">{{ detalleAgendaCita(item) }}</div>
              <div class="text-xs" :style="{ color: item.colorEstado }">{{ descripcionEstadoCompleta(item) }}</div>
            </div>

            <div class="relative">
              <font-awesome-icon :icon="['far', 'fa-eye']" class="text-2xl mr-2 text-gray-500" />
            </div>
          </div>
        </li>
      </ul>

    </div>
    <!-- Fin Agenda -->

  </div>

  <DetalleAgendaView v-if="detalleAgendaVisible" :closeFunction="closeDialogDetalleAgenda" :acreditado="acreditado" :detalleAgenda="detalleAgendaSeleccionada" />

  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import NavPill from "@/components/commons/NavPill.vue";
import DetalleAgendaView from './modal/DetalleAgendaView.vue';
import FullScreenLoader from '@/components/commons/FullScreenLoader.vue';

import { formatDate } from '@/utils/formatters';

import { Acreditado, ConfiguracionMeeting, DetalleAgenda, Evento } from "qreventos-suite/src/services/suite.interfaces";
import seguridadServices from "@/services/seguridad.services";
import meetingService from "qreventos-suite/meeting";
import configuracionMeetingService from '@/services/configuracion.merting.services';
import { RECHAZADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    FullScreenLoader,
    NavPill,
    DetalleAgendaView
  },
  data() {
    return {
      isSubmitting: false,
      acreditado: undefined as unknown as Acreditado,
      detallesAgenda: [] as DetalleAgenda[],
      fechas: [] as string[],
      fechaSeleccionada: '',
      detalleAgendaVisible: false,
      detalleAgendaSeleccionada: undefined as unknown as DetalleAgenda
    };
  },
  watch: {
    detalleAgenda: {
      handler(nuevo) {
        //this.detalleLocal = { ...nuevo };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatDate,
    async fillAcreditado(evento: Evento, hash: string) {
      this.acreditado = await meetingService.findAcreditadoMeetingBy(evento.id, hash);
    },
    async fillFechasBy(evento: Evento) {
      this.fechas = await meetingService.findFechasBy(evento.id);
      this.fechaSeleccionada = this.fechas[0];
    },
    async fillDetallesAgenda() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      this.detallesAgenda = await meetingService.findDetalleAgendaFechaBy(configuracionMeeting.evento.id, hash, 1, this.fechaSeleccionada);
    },
    async onChangeFechaCronograma(fecha: string) {
      try {
        this.isSubmitting = true;

        this.detallesAgenda = [] as DetalleAgenda[],
        this.fechaSeleccionada = fecha;
        await this.fillDetallesAgenda();

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    detalleAgendaCita(item: DetalleAgenda): string {
      let lineaAgenda: string = "";

      if (item.contraparte) {
        lineaAgenda += item.contraparte.nombre + " " + item.contraparte.apellido;
      }
      if (item.empresa && item.empresa.nombreFantasia) {
        lineaAgenda += " - " + item.empresa.nombreFantasia;

        if (item.empresa.pabellon) {
          lineaAgenda += " - " + this.$t('label.pabellon') + " : " + item.empresa.pabellon;
        }
        if (item.empresa.stand) {
          lineaAgenda += " - " + this.$t('label.numero.stand') + " : " + item.empresa.stand;
        }
      }
      if (item.observaciones) {
        lineaAgenda += (lineaAgenda.length > 0 ? " - " : "") + item.observaciones;
      }
      return lineaAgenda;
    },
    descripcionEstadoCompleta(item: DetalleAgenda):string {
      let lineaEstado: string = "";

      lineaEstado = item.descripcionEstado;

      if (item.idDetalleEstadoAgenda === 1 || item.idDetalleEstadoAgenda === 2 || item.idDetalleEstadoAgenda === 3) {
        if (this.acreditado.id === item.acreditadoSolicitante?.id) {
          lineaEstado += " " + this.$t('label.por') + " " + item.contraparte.nombre + " " + item.contraparte.apellido;
        } else {
          lineaEstado += " " + this.$t('label.por') + " " + this.acreditado.nombre + " " + this.acreditado.apellido;
        }
      }

      return lineaEstado;
    },
    getIcono(item: DetalleAgenda) {
      switch (item.idDetalleEstadoAgenda) {
        case 1:
          return ['far', 'clock'];
        case 2:
          return ['fas', 'check'];
        case 3:
          return ['fas', 'times'];
        case 4:
          return ['fas', 'lock'];
        case 5:
          return ['fas', 'calendar'];
      }
    },
    /* Gestión de modal detalle agenda */
    async mostrarDetalleAgenda(item: DetalleAgenda) {
      this.detalleAgendaSeleccionada = item;
      this.detalleAgendaVisible = true;
    },
    closeDialogDetalleAgenda(reload: boolean = false) {
      this.detalleAgendaVisible = false;
      this.detalleAgendaSeleccionada = undefined as unknown as DetalleAgenda;
      if (reload) {
        try {
          this.fillDetallesAgenda();
        } catch (error) {
          this.isSubmitting = false;
          Swal.fire({ title: "Error", text: error + '', icon: "error" });
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    /* Fin gestión de modal detalle agenda */
    async downloadAgendaPdf() {
      try {
        this.isSubmitting = true;

        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        const lang: string = this.$i18n.locale;
        await meetingService.downloadAgendaPdf(configuracionMeeting.evento.id, hash, lang);

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    try {
      this.isSubmitting = true;
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      await Promise.all([
        this.fillFechasBy(configuracionMeeting.evento),
        this.fillAcreditado(configuracionMeeting.evento, hash)
      ]);
      await this.fillDetallesAgenda();

    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>